import { API, post } from '../../net/http';

export default {
  namespaced: true,
  actions: {
    searchViews(context, body) {
      return post(API.review, body).then(res => {
        return res;
      });
    },
  },
};
